/*
================================================================ 
          Copyright (c) 2018-2020 Digitize Things Inc.           
                      All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "./cart.module.css";
import Button from "../../../component/button";
import { withTranslation } from "react-i18next";
import currencyFormatter from "../../../helper/currencyFormatter";

// Create accessory and return to parent (Cart)
const CartAcc = (props) => {
  const t = props.t;
  return (
    <React.Fragment>
      <div className={classes.accItemDiv}>
        <div style={{ width: "2.5rem" }}>
          {/* Remove accessory from cart */}
          <Button
            className={classes.removeButton}
            onClick={() => {
              props.removeAcc(props.index);
            }}
          >
            <span>x</span>
          </Button>
        </div>
        <div className={classes.componentNameDiv}>
          <span>
            <span>
              <input
                className={classes.quantityInput}
                type="number"
                min="1"
                step="1"
                value={props.accessory.quantity}
                onChange={(e) => {
                  props.changeQuantity(e.target.value);
                }}
              />
            </span>
            <span>{` x ${props.accessory.name} (${props.accessory.quantity} x ${currencyFormatter("", false)}${props.accessory.price} )`}</span>
          </span>
        </div>
        <div className={classes.priceDiv}>
          <span className={classes.priceSpan}>
            {currencyFormatter("", false)}
            {(
              Math.round(
                props.accessory.quantity * props.accessory.price * 100,
              ) / 100
            ).toFixed(2)}
          </span>
          <span className={classes.priceSpan}>
            {currencyFormatter("", false)}0.00
          </span>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation("translations")(CartAcc);
